import { useState } from "react";

function AdminChat() {
  const [pitanje, setPitanje] = useState("");
  const [odg, setOdgovor] = useState("");

  //Koristimo 4o
  let sendPitanje = async (e) => {
    e.preventDefault();
    const res = await fetch(`${process.env.REACT_APP_API_URL}/adminChat`, {
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title: pitanje }),
      method: "POST",
    });
    const data = await res.json();
    console.log("Chat response:", data);

    // console.log("data", data.description);

    setOdgovor(data.description);
    setPitanje("");
  };

  const onPitanjeChanged = (e) => setPitanje(e.target.value);

  return (
    <div className="">
      <header className="mb-3">
        <div className="">
          <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
            Chat
          </h1>
        </div>
      </header>
      <hr className="border-t border-slate-950" />
      <main className="">
        <div className="grid grid-cols-1 gap-x-8 gap-y-8 pt-5 md:grid-cols-3">
          <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-3">
            <div className="px-4 py-4 sm:p-4">
              <div className="grid w-full grid-cols-1 gap-y-1">
                <div>
                  <label
                    htmlFor="about"
                    className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5"
                  >
                    Odgovor
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="about"
                      name="about"
                      value={odg}
                      rows={3}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      style={{ height: "500px", overflowY: "auto" }} // Increased height
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="first-name"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Uneti pitanje
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="first-name" // Changed ID for textarea
                      value={pitanje}
                      onChange={onPitanjeChanged}
                      rows={4} // Set the number of visible rows
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                      style={{ height: "100px", overflowY: "auto" }} // Set height as needed
                    />
                  </div>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    onClick={sendPitanje}
                    className="mt-2 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  >
                    Pitaj
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
      <div>dddddddd</div>
    </div>

    // <div className="">
    //   <header className="mb-3">
    //     <div className="">
    //       <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
    //         Chat
    //       </h1>
    //     </div>
    //   </header>
    //   <hr className="border-t border-slate-950" />
    //   <main className="">
    //     <div className="grid grid-cols-1 gap-x-8 gap-y-8 pt-5 md:grid-cols-3">
    //       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-3">
    //         <div className="px-4 py-4 sm:p-4">
    //           <div className="grid w-full grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
    //             <div className="sm:col-span-2">
    //               <label
    //                 htmlFor="first-name"
    //                 className="block text-sm font-medium leading-6 text-gray-900"
    //               >
    //                 Uneti pitanje
    //               </label>
    //               <div className="mt-2">
    //                 <input
    //                   id="first-name"
    //                   value={pitanje}
    //                   onChange={onPitanjeChanged}
    //                   type="text"
    //                   autoComplete="given-name"
    //                   className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
    //                 />
    //               </div>
    //             </div>
    //             <div className="sm:col-span-10">
    //               <label
    //                 htmlFor="about"
    //                 className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5"
    //               >
    //                 Odgovor
    //               </label>
    //               <div className="mt-2 sm:col-span-2 sm:mt-0">
    //                 <textarea
    //                   id="about"
    //                   name="about"
    //                   value={odg}
    //                   rows={3}
    //                   style={{ height: "400px", overflowY: "auto" }}
    //                   className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
    //                   defaultValue={""}
    //                 />
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //         <div className="flex items-center justify-end gap-x-6 border-gray-900/10 px-4 py-4 sm:px-8">
    //           {/* <button
    //         type="button"
    //         className="text-sm font-semibold leading-6 text-gray-900"
    //       >
    //         Cancel
    //       </button> */}
    //           <button
    //             type="submit"
    //             onClick={sendPitanje}
    //             className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
    //           >
    //             Pitaj
    //           </button>
    //         </div>
    //       </form>
    //     </div>
    //   </main>
    // </div>
  );
}

export default AdminChat;
